import script from "./Section.vue?vue&type=script&setup=true&lang=ts"
export * from "./Section.vue?vue&type=script&setup=true&lang=ts"

import "./Section.vue?vue&type=style&index=0&id=70247b70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70247b70"]])

export default __exports__